import { useCallback, useState } from "react";

export const useAccordionState = (initialState = []) => {
  const [openItems, setOpenItems] = useState(initialState);

  const manageOpenItems = (eventKey) => {
    if (openItems.includes(eventKey)) {
      setOpenItems(openItems.filter((key) => key !== eventKey));
    } else {
      setOpenItems([...openItems, eventKey]);
    }
  };

  // 閉じている場合のみ開く（外部から特定の章を開く用）
  const openItem = useCallback((eventKey) => {
    setOpenItems((prev) =>
      prev.includes(eventKey) ? prev : [...prev, eventKey]
    );
  }, []);

  return { openItems, manageOpenItems, openItem };
};
